// @ts-expect-error pure js
import { TenantStatus } from "../../models/tenant_old.js";
import { Tabs } from "../UI/Tabs/Tabs";
import ShowTenantList from "./ShowTenantList";
import type { Tenant } from "../../models/tenant";

interface TenantListProps {
  tenants: Tenant[];
  onAdd?: () => void;
  isLoading: boolean;
}

export default function TenantList({
  tenants,
  onAdd,
  isLoading,
}: TenantListProps) {
  const sorted = [...tenants].sort((a, b) =>
    a.nom.localeCompare(b.nom, "fr", { sensitivity: "base" }),
  );
  const actifs = sorted.filter(
    (tenant) => tenant.status === TenantStatus.Actif.status,
  );

  return (
    <Tabs id="tenant-list" defaultValue="locataires-actifs">
      <div className="container bg-blue paddingT10 border-blue">
        <div className="content">
          <Tabs.List>
            <Tabs.Tab value="locataires-actifs">
              Locataires actifs ({actifs.length})
            </Tabs.Tab>
            <Tabs.Tab value="archives">Locataires archivés</Tabs.Tab>
          </Tabs.List>
        </div>
      </div>
      <div className="blueSpace"></div>
      <div className="content">
        <Tabs.Panel value="locataires-actifs">
          <ShowTenantList
            tenants={actifs}
            onAdd={onAdd}
            addLabel="Ajouter un locataire"
            isLoading={isLoading}
          />
        </Tabs.Panel>
        <Tabs.Panel value="archives">
          <ShowTenantList tenants={sorted} isArchived isLoading={isLoading} />
        </Tabs.Panel>
      </div>
    </Tabs>
  );
}
